import React from "react";
import CommonImageSlider from "./comandata";
import { acadmicImages, homeImages, interslider, jeeRanks, studentsRanks } from "./data";
import CallandRegisterComponent from "./Callbutton";
import RankridgeInter from "./rankridgeintermediate";
import SeoMeta from "./seometa/seometa";
import CommonImageSliderRanks from "./CommonsliderRanks";
import { CommonAboutHeader } from "./CommonAboutHeader";
import RankridgeIntermediate from "./subcomponents/RankridgeIntermediate";


const seoIntermediate = {
  title: "Intermediate with IIT & NEET | Best Junior College Hyderabad",
  description: "Join Rankridge for MPC & BiPC Intermediate with IIT JEE & NEET Long Term Coaching. Hyderabad’s trusted junior college with top results & expert faculty.",
  keywords: "MPC Junior College Hyderabad, BiPC Junior College Hyderabad, Best Intermediate Colleges in Hyderabad for MPC, Best Intermediate Colleges in Hyderabad for BiPC, MPC Residential Junior Colleges Hyderabad, BiPC Residential Junior Colleges Hyderabad, IIT JEE Foundation Junior College Hyderabad, NEET Foundation Junior College Hyderabad, Best MPC Colleges in Hyderabad, Best BiPC Colleges in Hyderabad, Junior Colleges with Hostel Facility Hyderabad, Best Junior Colleges for IIT JEE Coaching, Best Junior Colleges for NEET Coaching, Top MPC Junior Colleges Hyderabad, Top BiPC Junior Colleges Hyderabad, Rankridge Junior College MPC, Rankridge Junior College BiPC, MPC with IIT JEE Foundation Hyderabad, BiPC with NEET Foundation Hyderabad, Best MPC Residential Colleges in Hyderabad, Best BiPC Residential Colleges in Hyderabad, Intermediate Science Colleges Hyderabad, Junior Colleges with Sports Facilities Hyderabad, Best Colleges for 11th and 12th Science in Hyderabad, Top Junior Colleges Near Kukatpally, Rankridge IIT JEE Coaching, Rankridge NEET Coaching, Best Junior College Admissions Hyderabad, Intermediate MPC and BiPC Colleges in Hyderabad",
  canonical_path: "https://www.rankridge.com/best-junior-college-in-hyderabad/",
  og_description: "",
  og_image: "",
};

const Intermediate = () => {
  return (
    <div>
       {/* <h1 className="text-center text-xl font-bold"> Rankridge – Hyderabad’s Best Intermediate College with IIT-JEE & NEET Coaching Excellence</h1>


<CommonImageSliderRanks images={studentsRanks} />
      <CallandRegisterComponent  />

                    <p className="text-xl mt-5 text-center">“Where Academic Excellence Meets Competitive Success.”</p>

      <CommonAboutHeader images={interslider} /> */}

      {/* <div className="mb-10 mt-8 mx-2">
        <CallandRegisterComponent />
      </div> */}

       {/* <RankridgeInter /> */}
       <RankridgeIntermediate />
       <SeoMeta seopages={seoIntermediate} />
    </div>
  );
};

export default Intermediate;
